__turbopack_context__.v({
  "button": "CywIoq_button",
  "closeIcon": "CywIoq_closeIcon",
  "fadeAppear": "CywIoq_fadeAppear",
  "fadeAppearActive": "CywIoq_fadeAppearActive",
  "fadeEnter": "CywIoq_fadeEnter",
  "fadeEnterActive": "CywIoq_fadeEnterActive",
  "fadeExit": "CywIoq_fadeExit",
  "fadeExitActive": "CywIoq_fadeExitActive",
  "links": "CywIoq_links",
  "menuIcon": "CywIoq_menuIcon",
  "mobileMenu": "CywIoq_mobileMenu",
  "open": "CywIoq_open",
  "overlay": "CywIoq_overlay",
  "slideDownAppear": "CywIoq_slideDownAppear",
  "slideDownAppearActive": "CywIoq_slideDownAppearActive",
  "slideDownEnter": "CywIoq_slideDownEnter",
  "slideDownEnterActive": "CywIoq_slideDownEnterActive",
  "slideDownExit": "CywIoq_slideDownExit",
  "slideDownExitActive": "CywIoq_slideDownExitActive",
  "slideRightAppear": "CywIoq_slideRightAppear",
  "slideRightAppearActive": "CywIoq_slideRightAppearActive",
  "slideRightEnter": "CywIoq_slideRightEnter",
  "slideRightEnterActive": "CywIoq_slideRightEnterActive",
  "slideRightExit": "CywIoq_slideRightExit",
  "slideRightExitActive": "CywIoq_slideRightExitActive",
  "wrapper": "CywIoq_wrapper",
});
